export const CUSTOMER_SETTINGS_REQUEST = 'CUSTOMER_SETTINGS_REQUEST';
export const CUSTOMER_SETTINGS_FAILURE = 'CUSTOMER_SETTINGS_FAILURE';
export const CUSTOMER_SETTINGS_SUCCESS = 'CUSTOMER_SETTINGS_SUCCESS';
